import { cn } from "@/lib/utils";
import type { Facet } from "@apptus/esales-api";
import ClearFilter from "@features/filter/components/ClearFilter";
import Filter from "@features/filter/components/Filter";
import { Market } from "@features/market/config/i18n-config";
import { ComponentProps } from "react";

type SearchFilterPanelProps = {
  facets: Facet[];
  market: Market;
  clearLabel: string;
  className?: string;
  clearClassName?: string;
} & ComponentProps<"aside">;

export default function SearchFilterPanel({
  facets,
  market,
  clearLabel,
  className,
  clearClassName,
  ...props
}: SearchFilterPanelProps) {
  return (
    <aside className={cn("flex flex-col gap-y-4", className)} {...props}>
      <Filter
        facets={facets}
        market={market}
        className="overflow-y-auto scroll-smooth"
      />
      <ClearFilter className={cn("mx-4", clearClassName)}>
        {clearLabel}
      </ClearFilter>
    </aside>
  );
}
